import React, { useEffect } from 'react'
import imageNlist from "./nlist.png"

//Redux
import { useDispatch } from 'react-redux';
import { titleLabelAction } from '../../ReduxStore/Action/TitleLabelAction';

const KhunNLIST = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(titleLabelAction({ titleLabel: "N-LIST" }))
    }, [])

    return (
        <>
            {/* <iframe src="https://nlist.inflibnet.ac.in?igu=1" frameBorder={0} width={"100%"} height={"500px"} ></iframe> */}


            <a href="https://nlist.inflibnet.ac.in" target="_blank" rel="noopener noreferrer">
                <img src={imageNlist} alt="" className='img-fluid'
                    style={{ userSelect: "none" }}
                />
            </a>

        </>
    )
}

export default KhunNLIST